export default "__VITE_ASSET__BlT8QgDS__"